import { IProduct } from '@src/models/entities';

export function buildProductLogoFullUrl(logo: string, small: boolean) {
  if (small) {
    return `https://cdn.centra.ai/product-logo/r/150x-/${logo}`;
  }
  return `https://cdn.centra.ai/product-logo/o/${logo}`;
}

export const buildLogoUrl = (product: IProduct | undefined, small: boolean) => {
  //@ts-ignore
  return product?.newLogo?.imageSizeUrls?.main || buildProductLogoFullUrl(product?.logo || '', small);
};
